var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitOurHelpCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visit_our_help_center",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.953,
    height: 30,
    viewBox: "0 0 26.953 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2104",
    "data-name": "Group 2104",
    transform: "translate(18.71 22.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    d: "M357,396a1,1,0,1,0,1,1A1,1,0,0,0,357,396Z",
    transform: "translate(-356 -396)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2106",
    "data-name": "Group 2106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8564",
    "data-name": "Path 8564",
    d: "M47.365,21.308,44.58,20.38l-1-2a6.417,6.417,0,0,0,1.737-3.4l.125-.747h1.066a1.76,1.76,0,0,0,1.758-1.758V8.789a8.789,8.789,0,0,0-17.578,0V12.48a1.761,1.761,0,0,0,1.172,1.657v.687a1.76,1.76,0,0,0,1.758,1.758h.515a6.356,6.356,0,0,0,.983,1.522c.083.1.17.188.258.278l-1,2-2.785.928A8.636,8.636,0,0,0,26,29.414a.586.586,0,0,0,.586.586H52.367a.586.586,0,0,0,.586-.586,8.637,8.637,0,0,0-5.588-8.106Zm-.271-8.828a.587.587,0,0,1-.586.586h-.894c.149-1.154.248-2.381.288-3.591v-.1h1.189Zm-14.648.586a.587.587,0,0,1-.586-.586V9.375h1.189q0,.092.006.184v.006h0c.041,1.176.139,2.372.285,3.5h-.894Zm1.172,2.344a.587.587,0,0,1-.586-.586v-.586h.48l.125.748c.024.142.053.284.087.424ZM33.032,8.2h-1.15a7.617,7.617,0,0,1,15.19,0h-1.15A5.935,5.935,0,0,0,40,2.344H38.952A5.935,5.935,0,0,0,33.032,8.2Zm5.92-4.688H40a4.764,4.764,0,0,1,4.749,4.77v.5l-.733-.1a9.415,9.415,0,0,1-5.293-2.647.586.586,0,0,0-.414-.172,5.3,5.3,0,0,0-4.076,1.928,4.763,4.763,0,0,1,4.719-4.272Zm-4.014,11.9a33.493,33.493,0,0,1-.7-5.687l.789-1.052a4.124,4.124,0,0,1,3.05-1.634,10.6,10.6,0,0,0,5.774,2.8l.863.123c-.058,1.224-.175,2.452-.344,3.581h0c-.054.363-.1.6-.2,1.249a4.977,4.977,0,0,1-3.532,4,4.61,4.61,0,0,1-5.175-2.214h1.194A1.761,1.761,0,0,0,38.3,17.754h1.172a1.758,1.758,0,0,0,0-3.516H38.3a1.759,1.759,0,0,0-1.658,1.172Zm3.318,4.571a5.877,5.877,0,0,0,2.179.049l-1.035,1.1Zm.338,2-1.858,1.965A22.324,22.324,0,0,1,35.424,20.9l.7-1.4Zm4.139-2.671.8,1.594a22.32,22.32,0,0,1-1.312,3.043l-1.989-1.989ZM37.719,16a.586.586,0,0,1,.586-.586h1.172a.586.586,0,1,1,0,1.172H38.3A.587.587,0,0,1,37.719,16ZM27.2,28.828a7.4,7.4,0,0,1,4.764-6.408L34.43,21.6A23.488,23.488,0,0,0,36.1,25.216v.006h0a23.5,23.5,0,0,0,1.6,2.449l.721,1.157Zm12.281-.522-.795-1.276-.028-.042a22.34,22.34,0,0,1-1.32-1.972l2.09-2.21,2.2,2.2a22.316,22.316,0,0,1-1.325,1.98c-.032.041.009-.02-.826,1.32Zm1.055.522.721-1.157A23.486,23.486,0,0,0,42.868,25.2l.009-.016h0a23.47,23.47,0,0,0,1.65-3.587l2.466.822a7.4,7.4,0,0,1,4.764,6.408H40.532Z",
    transform: "translate(-26)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108",
    transform: "translate(17.438 20.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8565",
    "data-name": "Path 8565",
    d: "M395.594,418.744a10.029,10.029,0,0,0-2.84-3.447,1,1,0,1,0-1.223,1.59,8.012,8.012,0,0,1,2.268,2.754,1,1,0,0,0,1.795-.9Z",
    transform: "translate(-391.139 -415.088)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitOurHelpCenter);
export default __webpack_public_path__ + "static/media/visit_our_help_center.fd4895835ce10768a8b05eb12d4e0357.svg";
export { ForwardRef as ReactComponent };